export const historicalPricesReportLocation =
  "/reports/exchbusiness/historicalprices";
